module.exports = __webpack_public_path__ + "img/snapmed_white_logo.557a7812.svg";